import {GET_AGENCIES, GET_ENVELOPES, GET_STATUSES} from '../actions/esignature';

const initialState = {
    agencies: [],
    envelopes: [],
    statuses: []
};

export const esignatureReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_AGENCIES:
            return {...state, agencies: action.agencies};
        case GET_ENVELOPES:
            return {...state, envelopes: action.envelopes};
        case GET_STATUSES:
            return {...state, statuses: action.statuses};
        default:
            return {...state};
    }
};